<button mat-flat-button color="primary" (click)="openScheduleMeetingDialog()" data-action="clicked-book-meeting-button">
  {{ 'MEETING_SCHEDULER.MEETING_ACTION.DIALOG.BOOK_MEETING' | translate }}
</button>

<button mat-icon-button [matMenuTriggerFor]="menu">
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button mat-menu-item [routerLink]="meetingSettingsListViewPage$ | async" data-action="clicked-meeting-settings">
    {{ 'MEETING_SCHEDULER.MEETING_LIST.MEETING_SETTINGS' | translate }}
  </button>
</mat-menu>
